import { inject, Injectable } from '@angular/core';
import { BookingConfirmationService, SelfBookingManagerService, TimeSlotBookingModel, TimeSlotMetadata } from '@shared/booking-feature';
import { AppRoutingManagerService } from '@shared/core';
import { AuthManagerPwaService } from '@shared/data';
import { first, map, Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ScreenBookingConfirmationService extends BookingConfirmationService {
    private readonly appRoutingManager = inject(AppRoutingManagerService);
    private readonly selfBookingManager = inject(SelfBookingManagerService);
    private readonly authManager = inject(AuthManagerPwaService);

    confirmBooking(slot: TimeSlotBookingModel, metadata: TimeSlotMetadata): Observable<boolean> {
        return this.authManager.userStatus$.pipe(
            first(),
            switchMap(userStatus => {
                this.selfBookingManager.setConfirmationSlot(slot, metadata);
                if (userStatus?.requiresEmso) {
                    this.appRoutingManager.navigate('/onboarding/emso');
                    return of(false);
                }
                return this.appRoutingManager.toBookingConfirmation().pipe(map(() => true));
            }),
        );
    }
}
